import { ActiveGameScreen } from '@/screens/index'

export default function () {
  return <ActiveGameScreen />
}
